import { useMutation } from '@tanstack/react-query';
import { httpCompleteTask } from 'services/backofficeIntegration/http/endpoints/onboardingChecklist/httpCompleteTask';

export function useMarkTaskAsCompleted() {
  return useMutation({
    mutationFn: (taskId: number) => httpCompleteTask.callEndpoint(taskId)
  });
}
